/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  nbPoint: 0,
  customer_No: '',
  username: "cogepha",
  uid: 0,          // From Auth
  displayName: "", // From Auth
  image: require('../../public/profile_default.png'),
  status: "online",
  userRole: "",
  "id": '0',
  "nom": "",
  "email": "",
  "prenom": "",
  "dob": "",
  "genre": "",
  "role": "",
  "is_verified": true,
  "department": "",
  "mobile": "",
  "website": "",
  "languages_known": ["English", "Arabic"],
  "contact_options": ["email", "message", "phone"],
  "location": {
    "add_line_1": "",
    "add_line_2": "",
    "post_code": "",
    "ville": {
      id: 0,
      designation: "",
      "gouvernorat": {
        id: 0,
        designation: "",
        "pays": {
          id: 0,
          designation: "",
        }
      }
    }
  },
  "social_links": {
    "twitter": "",
    "facebook": "",
    "instagram": "",
  },
  "societe": {
    "nom": "",
    "pays": {
      id: 0,
      designation: ""
    },
    "gouvernorat": {
      id: 0,
      designation: "",
      idPays: 0
    },
    "ville": {
      id: 0,
      designation: "",
      idGouvernorat: 0
    },
    "adresse": "",
    "telephone": "",
    "fax": "",
    "siteWeb": "",
    "longtitude": "",
    "latitude": ""
  }

}
const livreurDefaults =
{
  "id": "",
  "position": {
    longtitude: "",
    latitude: "",
  }

}
const state = {
  AppActiveUser: userDefaults,
  AppActiveLivreur: livreurDefaults,
  received_messages: [],
  send_message: null,
  connected: false,
  socket: null,
  stompClient: null,
  bodyOverlay: false,
  isVerticalNavMenuActive: true,
  mainLayoutType: themeConfig.mainLayoutType || "vertical",
  navbarSearchAndPinList: navbarSearchAndPinList,
  reduceButton: themeConfig.sidebarCollapsed,
  verticalNavMenuWidth: "default",
  verticalNavMenuItemsMin: false,
  scrollY: 0,
  starredPages: navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
  theme: themeConfig.theme || "light",
  themePrimaryColor: colors.success,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
}

export default state
